import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { AuthService } from "../../shared/services/auth.service";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class UserConfigLotService {
  constructor(private http: HttpClient, private authService: AuthService) { }

  addUser(user: any): Observable<any> {
    return this.http.post(`${environment.apiUrl}/users`, user);
  }

  getUsers(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/users`);
  }

  toggleUserActive(email: string, active: boolean) {
    return this.http.put(`${environment.apiUrl}/users/active`, {
      email,
      active
    });
  }

  resetPassword(email: string): Observable<any> {
    return this.http.put(`${environment.apiUrl}/users/reset`, { email });
  }

  getUserPermissions(userId: string, pageSize: number, page: number): Observable<any> {
    return this.http.get(`${environment.apiUrl}/user-permission`, {
      params: { userId, pageSize: pageSize.toString(), page: page.toString() }
    });
  }

  updateUserPermissions(data: any): Observable<any> {
    return this.http.put(`${environment.apiUrl}/user-permission-update`, data);
  }
}